import {
  DeleteObjectCommand,
  GetObjectCommand,
  ListObjectsCommand,
  PutObjectCommand,
  S3Client,
} from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';

const bucket = process.env.REACT_APP_AWS_S3_BUCKET;
const region = process.env.REACT_APP_AWS_REGION;

const uploadS3Item = async (credentials, files, key) => {
  try {
    const file = files[0];
    const fileName = file.name;

    const client = new S3Client({
      region,
      credentials,
    });

    await client.send(
      new PutObjectCommand({
        Bucket: bucket,
        Key: `${key}/${fileName}`,
        Body: file,
        ContentType: file.type,
      })
    );
  } catch (err) {
    throw new Error(err.message);
  }
};

const listS3Items = async (credentials, prefix) =>
  new Promise((resolve, reject) => {
    const client = new S3Client({
      region,
      credentials,
    });

    client
      .send(
        new ListObjectsCommand({
          Bucket: bucket,
          Prefix: prefix,
        })
      )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

const viewS3Items = async (credentials, key) => {
  const client = new S3Client({
    region,
    credentials,
  });

  const command = new GetObjectCommand({
    Bucket: bucket,
    Key: key,
  });

  const url = await getSignedUrl(client, command, { expiresIn: 3600 });

  return {
    url,
    key,
  };
};

const deleteS3Item = async (credentials, key) => {
  try {
    const client = new S3Client({
      region,
      credentials,
    });

    const command = {
      Bucket: bucket,
      Key: key,
    };

    await client.send(new DeleteObjectCommand(command));
  } catch (err) {
    throw new Error(err.message);
  }
};

export { uploadS3Item, listS3Items, viewS3Items, deleteS3Item };
